module.exports = __webpack_public_path__ + "static/media/about-us-2.61248994.jpg";